import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import { motion } from "framer-motion";
import { tokens } from "../../../store/tokens";

// const points = [
//   { icon: RocketLaunchIcon, label: "Launch your career from anywhere" },
//   { icon: PsychologyAltIcon, label: "Work your way with full flexibility" },
//   { icon: AutoAwesomeIcon, label: "Smart matching with meaningful projects" },
//   { icon: Diversity3Icon, label: "Connect with clients across Bangladesh & the world" },
// ];
const points = [
  { icon: RocketLaunchIcon, label: "Work your way, from anywhere" },
  { icon: PsychologyAltIcon, label: "Build your profile, reputation & income" },
  { icon: AutoAwesomeIcon, label: "Sell your skills & services with ease" },
  { icon: Diversity3Icon, label: "Work with clients across Bangladesh & beyond" },
];

const listContainer = { hidden: {}, visible: { transition: { staggerChildren: 0.08 } } };
const listItem = { hidden: { opacity: 0, x: -14 }, visible: { opacity: 1, x: 0, transition: { duration: 0.4 } } };

const primaryButtonSx = {
  borderRadius: `${tokens.button.radius}px`,
  height: tokens.button.height.lg,
  px: `${tokens.button.paddingX.lg}px`,
  fontFamily: tokens.font.body,
  fontWeight: tokens.type.button.fontWeight,
  fontSize: tokens.button.fontSize.lg,
  textTransform: tokens.type.button.textTransform,
  bgcolor: tokens.bg.brand,
  color: tokens.color.white,
  boxShadow: "none",
  transition: "background-color 0.2s ease",
  "&:hover": { bgcolor: tokens.bg.brandDark },
};

const Keypoints = () => {
  return (
    <Container sx={{ mt: { xs: 6, md: 8, lg: 3 }, mb: { xs: 6, md: 8, lg: 10 } }}>
      <Stack direction={{ xs: "column", md: "row" }} alignItems="center" spacing={{ xs: 4, md: 5 }}>
        <Box
          component={motion.img}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          src="https://aps.songjukti.com/image/atop_banner/left_freelancer_home.png"
          alt="Freelancer working on a laptop"
          sx={{ width: { xs: "85%", md: "45%" }, borderRadius: `${tokens.radius.xl}px` }}
        />

        <Stack
          component={motion.div}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          spacing={2.5}
          sx={{ width: { xs: "100%", md: "55%" } }}
        >
          <Box
            sx={{
              display: "inline-flex",
              width: "fit-content",
              px: 1.75,
              py: 0.5,
              borderRadius: `${tokens.radius.pill}px`,
              bgcolor: tokens.color.tealLight,
              color: tokens.color.teal,
              fontFamily: tokens.font.body,
              fontWeight: 700,
              fontSize: "0.8rem",
            }}
          >
            Built for modern independent professionals
          </Box>

          <Typography
            sx={{
              fontFamily: tokens.font.heading,
              fontWeight: tokens.type.h2.fontWeight,
              letterSpacing: tokens.type.h2.letterSpacing,
              fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize },
              lineHeight: tokens.type.h2.lineHeight,
              color: tokens.textOn.light.primary,
            }}
          >
            Get discovered. Work smarter.
          </Typography>

          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: tokens.type.body1.fontSize,
              lineHeight: tokens.type.body1.lineHeight,
              color: tokens.textOn.light.secondary,
            }}
          >
            Showcase what you do, get matched with relevant projects and connect directly with clients looking for your expertise. Songjukti gives freelancers the freedom to work flexibly, grow their reputation and turn skills into sustainable opportunities.
          </Typography>

          <Grid
            container
            spacing={2}
            component={motion.div}
            variants={listContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            {points.map(({ icon: Icon, label }) => (
              <Grid item xs={12} sm={6} key={label} component={motion.div} variants={listItem}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 36,
                      height: 36,
                      borderRadius: `${tokens.radius.sm}px`,
                      bgcolor: tokens.color.tealLight,
                      flexShrink: 0,
                      transition: "transform 0.2s ease",
                      "&:hover": { transform: "scale(1.1)" },
                    }}
                  >
                    <Icon sx={{ color: tokens.color.teal, fontSize: 20 }} />
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: tokens.font.body,
                      fontWeight: tokens.type.subtitle1.fontWeight,
                      fontSize: tokens.type.body1.fontSize,
                      color: tokens.textOn.light.primary,
                    }}
                  >
                    {label}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>

          <Button
            component={motion.button}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => window.open("https://user.songjukti.com", "_blank")}
            variant="contained"
            size="large"
            sx={{ ...primaryButtonSx, mt: 1, width: "fit-content" }}
          >
            Explore community
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Keypoints;